// types
import type { AdditionalSelectors, ConfigDDJ } from '../types';

// store
import { Selectors, uninitializedSelectors } from './selectors';

export let ddjSelectors: Selectors = new Selectors(uninitializedSelectors);
export let ddjConfig: ConfigDDJ = { source: '' };

export const init = (
    additionalSelectors: AdditionalSelectors,
    config: ConfigDDJ
): {
    selectors: Selectors;
} => {
    ddjConfig = config;
    ddjSelectors = new Selectors(additionalSelectors);

    return {
        selectors: ddjSelectors
    };
};

/**
 * Resets the module state. Exported for tests only — the host calls init() once
 * per bootstrap and never needs to tear it back down.
 */
export const resetDdjConfig = () => {
    ddjSelectors = new Selectors(uninitializedSelectors);
    ddjConfig = { source: '' };
};

/*
 * Components must read the host's state through these functions rather than
 * through `ddjSelectors.getX` directly. init() swaps the Selectors instance, so
 * a bound method captured at render time would be stale; these wrappers keep a
 * stable identity for useSelector while always delegating to the current
 * instance.
 */
export const getDealXgId = (state: any): string => ddjSelectors.getDealXgId(state);

export const getDealRefId = (state: any): string => ddjSelectors.getDealRefId(state);

export const getPartnerCode = (state: any): string | undefined => ddjSelectors.getPartnerCode(state);

export const getPartnerDealerId = (state: any): string | undefined => ddjSelectors.getPartnerDealerId(state);

export const getSource = (): string => ddjConfig.source;

export const getDefaultPartnerId = (): string | undefined => ddjConfig.defaultPartnerId;
